import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Facebook, Instagram, Youtube, Clock } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { resolveImg } from "@/lib/api";
import { IslamicDivider } from "@/components/IslamicPattern";

const Footer = () => {
  const { settings } = useSite();
  const year = new Date().getFullYear();

  return (
    <footer className="mt-auto bg-emerald-950 text-emerald-50">
      <div className="mx-auto max-w-6xl px-6 py-12">
        <div className="grid gap-10 md:grid-cols-4">
          <div className="md:col-span-1">
            <div className="flex items-center gap-3">
              <img src={resolveImg(settings.logo_url)} alt="Logo MI Futuhiyyah" className="h-12 w-12 rounded-full bg-white object-contain p-0.5" />
              <div>
                <p className="font-heading font-bold text-white">MI Futuhiyyah</p>
                <p className="text-xs text-emerald-200">Doro - Pekalongan</p>
              </div>
            </div>
            <p className="mt-4 text-sm text-emerald-200/80 leading-relaxed">
              Madrasah Ibtidaiyah Futuhiyyah berkomitmen mencetak generasi Rabbani yang unggul dan berakhlak mulia.
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white mb-4">Navigasi</h4>
            <ul className="space-y-2 text-sm text-emerald-200/80">
              <li><Link to="/profil" className="hover:text-white transition-colors">Profil</Link></li>
              <li><Link to="/guru" className="hover:text-white transition-colors">Daftar Guru</Link></li>
              <li><Link to="/visi-misi" className="hover:text-white transition-colors">Visi & Misi</Link></li>
              <li><Link to="/berita" className="hover:text-white transition-colors">Berita</Link></li>
              <li><Link to="/kegiatan" className="hover:text-white transition-colors">Kegiatan</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white mb-4">Kontak</h4>
            <ul className="space-y-3 text-sm text-emerald-200/80">
              <li className="flex gap-2"><MapPin className="h-4 w-4 mt-0.5 shrink-0 text-emerald-400" /><span>{settings.address}</span></li>
              <li className="flex gap-2"><Phone className="h-4 w-4 shrink-0 text-emerald-400" /><span>{settings.phone}</span></li>
              <li className="flex gap-2"><Mail className="h-4 w-4 shrink-0 text-emerald-400" /><span>{settings.email}</span></li>
              <li className="flex gap-2"><Clock className="h-4 w-4 shrink-0 text-emerald-400" /><span>{settings.operational_hours}</span></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white mb-4">Media Sosial</h4>
            <div className="flex gap-3">
              {settings.facebook && <a href={settings.facebook} target="_blank" rel="noreferrer" data-testid="footer-facebook" className="rounded-full bg-emerald-900 p-2.5 hover:bg-emerald-700 transition-colors"><Facebook className="h-4 w-4" /></a>}
              {settings.instagram && <a href={settings.instagram} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="rounded-full bg-emerald-900 p-2.5 hover:bg-emerald-700 transition-colors"><Instagram className="h-4 w-4" /></a>}
              {settings.youtube && <a href={settings.youtube} target="_blank" rel="noreferrer" data-testid="footer-youtube" className="rounded-full bg-emerald-900 p-2.5 hover:bg-emerald-700 transition-colors"><Youtube className="h-4 w-4" /></a>}
            </div>
          </div>
        </div>

        <IslamicDivider className="mt-10 opacity-40" />
        <p className="mt-6 text-center text-xs text-emerald-200/60">
          © {year} Madrasah Ibtidaiyah Futuhiyyah, Doro - Pekalongan. Seluruh hak cipta dilindungi.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
